import { supabase } from '@/lib/supabase/client'

export type AIResponse = {
  response: string
  type: 'static' | 'ai' | 'fallback'
  source?: string
  error?: string
}

export const processUserMessage = async (
  message: string,
  sessionId: string,
): Promise<AIResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke('chat-ai', {
      body: { message, sessionId },
    })

    if (error) {
      console.error('Edge Function Error:', error)
      throw error
    }

    return data as AIResponse
  } catch (e) {
    console.error('Chat AI Service Error:', e)
    return {
      response:
        'Estou com dificuldades de conexão no momento. Pode tentar novamente?',
      type: 'fallback',
      error: 'Connection error',
    }
  }
}
